import { cn } from "@/lib/utils";
import Reveal from "./Reveal";

export default function SectionHeading({
  eyebrow,
  title,
  body,
  align = "left",
  className = "",
  testId = "",
}) {
  return (
    <Reveal
      className={cn(
        "max-w-3xl",
        align === "center" ? "mx-auto text-center" : "",
        className
      )}
    >
      {eyebrow && (
        <div className="eyebrow text-gold" data-testid={testId ? `${testId}-eyebrow` : undefined}>
          {eyebrow}
        </div>
      )}
      <h2
        className="font-display text-4xl md:text-5xl lg:text-[3.5rem] leading-[1.05] tracking-tight text-navy-900 mt-4"
        data-testid={testId ? `${testId}-title` : undefined}
      >
        {title}
      </h2>
      {body && (
        <p
          className="mt-6 text-lg md:text-xl text-navy-900/60 leading-relaxed font-light"
          data-testid={testId ? `${testId}-body` : undefined}
        >
          {body}
        </p>
      )}
      <div className={cn("divider-gold mt-8", align === "center" && "mx-auto")} />
    </Reveal>
  );
}
